import React from 'react';
import './Footer.css';
import MarketingText from 'components/MarketingText';
import SearchPO from 'SearchPO';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { isValidToken } from '../shared/utils/HelperFunctions';
import { connect } from 'react-redux';

const publicRoutePathFragments = [
    '/terms',
    '/vendorEnrollment',
    '/registration',
    '/contact',
    '/exceptions',
    '/sso',
    '/resetPassword',
    '/recoverPassword',
    '/ariuser',
    '/setupPassword',
    '/Persona/'
];

const Footer = (props) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const isTokenInvalid = !isValidToken(props.token);
    const isPublicRoute = publicRoutePathFragments.some((fragment) => currentPath.includes(fragment));

    return <div className="row container-fluid">
            <div className="d-none d-xl-block links offset-lg-1 col-lg-1 offset-xl-1 col-xl-2">
                &nbsp;
            </div>
            <div className="col-sm-12 offset-md-1 col-md-11 offset-lg-2 col-lg-8 offset-xl-0 col-xl-8">
                <div className="">
                    {isTokenInvalid && !isPublicRoute ? <Navigate to="/login" replace /> : null}

                    <Routes>
                        <Route path="/login" element={<MarketingText selectedCountry={props.selectedCountry}/>} />

                        <Route path="/" element={<SearchPO />} />
                        <Route path="/carWash" element={<SearchPO />} />
                        <Route path="/carWash/vehicle/:vehicleId" element={<SearchPO />} />
                        <Route path="/contact/HelpFAQ" element={
                            !isValidToken(props.token)
                                ? null
                                : <SearchPO />
                        } />
                        <Route path="/contact/FeedbackForm" element={
                            !isValidToken(props.token)
                                ? null
                                : <SearchPO />
                        } />
                        
                        <Route path="/yourAccount" element={<SearchPO />} />
                        <Route path="/ariuser" element={null} />
                        <Route path="/vehicle/:vehicleId/documents" element={<SearchPO />} />
                        <Route path="/learnMore" element={null} />
                        <Route path="/linkedVendorAccount" element={null} />
                        <Route path="/recoverPassword" element={null} />
                        <Route path="/resetPassword" element={null} />
                        <Route path="/registration/:step" element={null} />
                        <Route path="/attentionNeeded" element={<SearchPO />} />
                        <Route path="/AccidentManagement/*" element={<SearchPO />} />
                        <Route path="/Persona/*" element={null} />
                        <Route path="/terms" element={null} />
                        <Route path="/exceptions" element={null} />
                        <Route path="/dealerDrafts" element={<SearchPO />} />
                        <Route path="/dealerDrafts/:actionType/:requestNo" element={<SearchPO />} />

                        <Route path="/po/search" element={<SearchPO />} />
                        <Route path="/po/odometer/:vehicleId" element={<SearchPO />} />
                        <Route path="/po/repairHistory/:vehicleID" element={<SearchPO />} />
                        <Route path="/po/driverValidationComplaints/:vehicleId" element={<SearchPO />} />
                        <Route path="/po/complaint/:vehicleId" element={<SearchPO />} />
                        <Route path="/po/clientParameters/:vehicleID" element={<SearchPO />} />
                        <Route path="/po/actionRequired/:trackNumber" element={<SearchPO />} />
                        <Route path="/po/:actionType/:trackNumber" element={<SearchPO />} />

                        <Route path="/vehicles/vin8/:vin8/:actionType" element={<SearchPO />} />
                        <Route path="/vehicles/plate/:plate/state/:state/:actionType" element={<SearchPO />} />
                        <Route path="/vehicles/clientId/:clientId/unitNo/:unitNo/:actionType" element={<SearchPO />} />
                        <Route path="/vehicles/serviceNo/:serviceNo/:actionType" element={<SearchPO />} />
                    </Routes>
                    
                </div>
            </div>
        </div>
};

function mapStateToProps(state, props) {    
    return {
        token: state.appState.getIn(['serverData', 'shared', 'token']),
        personaToken:state.appState.getIn(['serverData','shared','personaToken']),
        serviceClassification:state.appState.getIn(['serverData','shared','serviceClassification']),
    };
}

export default connect(mapStateToProps)(Footer);
